import { render, staticRenderFns } from "./PastYearsArrearsAlert.vue?vue&type=template&id=6cd72b73&scoped=true&"
import script from "./PastYearsArrearsAlert.vue?vue&type=script&lang=js&"
export * from "./PastYearsArrearsAlert.vue?vue&type=script&lang=js&"
import style0 from "./PastYearsArrearsAlert.vue?vue&type=style&index=0&id=6cd72b73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd72b73",
  null
  
)

export default component.exports